import { combineReducers } from 'redux';

// reducer import
import customizationReducer from './customizationReducer';
import AuthReducer from './Auth/AuthReducer';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    customization: customizationReducer,
    auth: AuthReducer
});

export default reducer;
